export default __webpack_public_path__ + "static/media/Age_icon.5ef04b1a.svg";